import { configureStore } from '@reduxjs/toolkit';
import authReducer from './Slices/authSlice';
import storeAuthReducer from './Slices/storeAuthSlice';
import userReducer from './Slices/UserSlice';
import orderReducer from './Slices/OrderSlice';
import settingsReducer from './Slices/SettingsSlice';
import CategoryReducer from './Slices/CategorySlice';
import SubCategoryReducer from './Slices/SubCategorySlice';
import BannerReducer from './Slices/BannerSlice';
import storeBranchesReducer from './Slices/storeBranchesSlice';
import ProductsSlice from './Slices/ProductsSlice';
import adminStoresReducer from './Slices/AdminStoresSlice';
import adminCategoriesReducer from './Slices/AdminCategoriesSlice';
import adminPharmaciesReducer from './Slices/AdminPharmaciesSlice';
import adminPharmacySettingsReducer from './Slices/AdminPharmacySettingsSlice';
import adminProductsReducer from './Slices/AdminProductsSlice';
import adminDeliveriesReducer from './Slices/AdminDeliveriesSlice';
import adminPharmacyRequestsReducer from './Slices/AdminPharmacyRequestsSlice';
import adminOrdersReducer from './Slices/AdminOrdersSlice';
import permissionsReducer from './Slices/PermissionsSlice';
import clinicProfileReducer from './Slices/ClinicProfileSlice';
import clinicDoctorsReducer from './Slices/ClinicDoctorsSlice';
import adminPromoCodesReducer from './Slices/AdminPromoCodesSlice';
import promoCodesReducer from './Slices/PromoCodesSlice';
import clinicBranchesReducer from './Slices/ClinicBranchesSlice';
import adminAppSettingsReducer from './Slices/AdminAppSettingsSlice';
import adminTechniciansReducer from './Slices/AdminTechniciansSlice';
import locationsReducer from './Slices/LocationsSlice';

export const store = configureStore({
  reducer: {
    auth: authReducer,
    storeAuth: storeAuthReducer,
    users: userReducer,
    orders: orderReducer,
    settings: settingsReducer,
    categories: CategoryReducer,
    subCategories: SubCategoryReducer,
    banners: BannerReducer,
    storeBranches: storeBranchesReducer,
    products: ProductsSlice,
    adminStores: adminStoresReducer,
    adminCategories: adminCategoriesReducer,
    adminPharmacies: adminPharmaciesReducer,
    adminPharmacySettings: adminPharmacySettingsReducer,
    adminProducts: adminProductsReducer,
    adminDeliveries: adminDeliveriesReducer,
    adminPharmacyRequests: adminPharmacyRequestsReducer,
    adminOrders: adminOrdersReducer,
    permissions: permissionsReducer,
    clinicProfile: clinicProfileReducer,
    clinicDoctors: clinicDoctorsReducer,
    adminPromoCodes: adminPromoCodesReducer,
    promoCodes: promoCodesReducer,
    clinicBranches: clinicBranchesReducer,
    adminAppSettings: adminAppSettingsReducer,
    adminTechnicians: adminTechniciansReducer,
    locations: locationsReducer,
  },
});
